// helpers
import { nykaaRxp } from 'shared/helpers/utils';
import { beautyRxp, nykaaManRxp } from 'shared/helpers/utils/regex';
import {
  OBJECT_JOIN_CHAR,
  FILTER_SEPARATOR,
  PRICE_JOIN_CHAR,
  OBJECT_JOIN_CHAR_ENCRYPT,
} from 'shared/layouts/Listing/Api/constants';
import { CANONICAL_HOMEPAGE_URL } from 'shared/constants/pages';

const HTTP_REGEXP = /^http/i;

const QUERY_STRING_SRC_IDENTIFIER = 'src';
const QUERY_STRING_SRC_VALUE = 'app';

export const isOurURL = (URL: string) => nykaaRxp.test(URL) || HTTP_REGEXP.test(URL) === false;

export const getCleanUrl = (URL: string) => (nykaaRxp.test(URL) ? URL.replace(nykaaRxp, '') : URL);

export const generateNykaaUrl = (url: string) => {
  url.replace(nykaaRxp, '');
  return `${CANONICAL_HOMEPAGE_URL}${url}`;
};

export const getPLPFilterParams = (data: string = '', sort: string = '') => {
  const sortParam = sort.trim();
  const dataSplit = data.split('&');

  const defaultValue =
    sortParam !== '' ? `sort=${sortParam.replace(OBJECT_JOIN_CHAR, OBJECT_JOIN_CHAR_ENCRYPT)}` : '';

  return dataSplit.reduce((filterValue, item) => {
    const newValue =
      item.includes('-') && !item.includes('-*')
        ? item.trim().replace('-', PRICE_JOIN_CHAR)
        : item.trim().replace(',', OBJECT_JOIN_CHAR) + OBJECT_JOIN_CHAR;

    return filterValue ? filterValue + FILTER_SEPARATOR + newValue : newValue;
  }, defaultValue);
};

const isOurHome = (currentPath: string) => {
  return currentPath === '/' || currentPath === '';
};

export const isSourceApp = (search = '') => {
  const urlParams = new URLSearchParams(search);

  // check for src=app in the url
  return (
    urlParams.has(QUERY_STRING_SRC_IDENTIFIER) &&
    // @ts-ignore
    urlParams.get(QUERY_STRING_SRC_IDENTIFIER).toLowerCase() === QUERY_STRING_SRC_VALUE
  );
};

export const isWebView = (location: Location<any>) => {
  if (isOurURL(location.href) === false) return false;

  return isSourceApp(location.search) && !isOurHome(location.pathname);
};

export const addQueryStringToURL = (url: string, queryString: string) => {
  if (url.indexOf('?') > -1) {
    return `${url}&${queryString}`;
  }

  return `${url}?${queryString}`;
};

export const isCrossPlatform = (url: string) => {
  return beautyRxp.test(url) || nykaaManRxp.test(url);
};
